module.exports = __webpack_public_path__ + "img/icon_dean_home_card_empty_icon_3.f59e2058.png";